import http from 'plugins/axios';

export default {
    getAllSupportCoin() {
        return http.get({
            url: '/admin/etpCoinConfig/etp/tradePair'
        });
    },

    getEtpCoinConfigList(data) {
        return http.get({
            url: '/admin/etpCoinConfig/list',
            data
        });
    },

    saveEtpCoinConfig(data) {
        return http.post({
            url: '/admin/etpCoinConfig/saveCoinConfig',
            data,
            dataType: "form"
        });
    },

    updateEtpCoinConfig(data) {
        return http.post({
            url: '/admin/etpCoinConfig/updateCoinConfig',
            data,
            dataType: "form"
        });
    },

    updateEtpConfigStatus(data) {
        return http.post({
            url: '/admin/etpCoinConfig/updateConfigStatus',
            data,
            dataType: "form"
        });
    },
};
